export default "__VITE_ASSET__BN5zl6MC__"